import _ from "lodash";

export class UtilTransform {
  private static getData(tempData: any, data: any, key: string): any {
    return tempData.hasOwnProperty(key) ? tempData[key] : data[key];
  }

  static process(data: any, transform: any): any {
    const tempData = {};
    transform.steps.forEach((step) => {
      let predicate = () => {};
      if (step.hasOwnProperty("predicate")) {
        step.predicate = step.predicate.replace(
          /{[A-Za-z]+}/gi,
          (m: string) => {
            const dataKey = m.replace("{", "").replace("}", "");
            if (tempData.hasOwnProperty(dataKey)) {
              return tempData[dataKey];
            }
            return m;
          }
        );
        predicate = eval(step.predicate);
      }
      switch (step.fn) {
        case "keyValue":
          tempData[step.name] = this.getData(tempData, data, step.data)[
            step.key
          ];
          break;
        case "find":
          tempData[step.name] = _.filter(
            this.getData(tempData, data, step.data),
            predicate
          );
          break;
        case "filter":
          const d = this.getData(tempData, data, step.data);
          tempData[step.name] = _.filter(d, predicate);
          break;
        case "csvToRowColData":
          data = this.getData(tempData, data, step.data);
          let cols = data.shift();
          cols.shift();
          let rows = data.map((v) => v.shift());
          data = data.map((v) => v.map((v) => parseFloat(v)));
          tempData[step.name] = { data, cols, rows };
          break;
        case "flatten":
          tempData[step.name] = _.flatten(
            this.getData(tempData, data, step.data)
          );
          break;
        case "zip":
          tempData[step.name] = _.zip(
            ...step.data.map((v) => this.getData(tempData, data, v))
          );
          break;
        case "filterh":
          tempData[step.name] = this.getData(tempData, data, step.data).find(
            (v) => v[0].toUpperCase() === step.gene.toUpperCase()
          );
          break;
        case "filterg":
          data = this.getData(tempData, data, step.data);
          let tissues = data[0];
          let gene = data.find(
            (v) => v[0].toUpperCase() === step.gene.toUpperCase()
          );
          tissues.shift();
          gene.shift();
          gene = gene.map((v) => parseFloat(v));
          tissues = tissues.map((v) => v.split("-")[1]);
          tempData[step.name] = _.zip(tissues, gene).sort(
            (a, b) => b[1] - a[1]
          );
          break;
      }
    });
    return transform.outputs.reduce((p, c) => {
      p[c] = tempData[c];
      return p;
    }, {});
  }
}
